import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import CarRow from '../../../components/Cars/CarRow'
import CarEditStatus from "../CarEditStatus/CarEditStatus"
import axios from 'axios'
import { APIURL, PAGE10 } from '../../../config/config'
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap'
import CarCalculate from '../../../components/Cars/CarCalculate'
import CarShare from '../../../components/Cars/CarShare'
import { connect } from 'react-redux'
import CarLeasingFormNew from '../CarLeasingFormNew'
import CarEditSellPrice from '../CarEditSellPrice'

class CarList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      lists: [],
      user: {},
      user_type: '',
      car_id: 0,
      action: 'บันทึก',
      car: '',
      car_edit_status: {},
      toggle_car_status_edit: false,
      toggle_car_calculate: false,
      toggle_car_share: false,
      car_calculate: {},
      car_share: {},
      count_car: 0,
      car_select: false,
      is_search: false,
      car_delete: {},
      toggle_car_status_delete: false,
      toggle_car_status_leasing: false,
      carLeasingList: [],
      page: 0,
      //
      car_edit_sell_price: {},
      toggle_car_edit_sell_price: false,
      sum_cost_all: 0
    }
    this.onCarStatusEdit = this.onCarStatusEdit.bind(this)
    this.toggleCarStatusEdit = this.toggleCarStatusEdit.bind(this)
    this.onCarStatusChange = this.onCarStatusChange.bind(this)
    this.toggleCarCalculate= this.toggleCarCalculate.bind(this);
    this.onCarCalculate = this.onCarCalculate.bind(this);
    this.onCarShare = this.onCarShare.bind(this);
    this.toggleCarShare = this.toggleCarShare.bind(this)
    this.onCarShareChange = this.onCarShareChange.bind(this)
    this.onRefreshCar = this.onRefreshCar.bind(this);
    this.toggleCarDelete = this.toggleCarDelete.bind(this);
    this.onCarDelete = this.onCarDelete.bind(this);
    this.toggleCarLeasing = this.toggleCarLeasing.bind(this);
    this.onCarLeasing = this.onCarLeasing.bind(this);
    this.onSubmitCarLeasing = this.onSubmitCarLeasing.bind(this);
    this.searchByCarStructure = this.searchByCarStructure.bind(this);
    this.onCarExplainFormEdit = this.onCarExplainFormEdit.bind(this);
    this.onCarExplainUpdate = this.onCarExplainUpdate.bind(this);
    //
    this.onCarEditSellPrice = this.onCarEditSellPrice.bind(this);
    this.toggleCarEditSellPrice = this.toggleCarEditSellPrice.bind(this);
    this.onSubmitCarEditSellPrice = this.onSubmitCarEditSellPrice.bind(this);
    //
    this.loadCarDataAsync = this.loadCarDataAsync.bind(this);
  }

  componentWillMount () {
    // this.mounted = true;
    //const queryString = require('query-string');
    var user = JSON.parse(this.props.user);
    this.setState({
      user: user ,
      user_type : user.type
    })
  }

  componentWillUnmount () {
    this.mounted = false;
  }

  loadCarData (page) {
    var uri = ''

    if (typeof page === 'undefined') page = 1

    if(this.state.user_type === 'admin'){
      uri = APIURL + '/car/page/'+page;
    }else if(this.state.user_type === 'sale'){
      uri = APIURL + '/car/page/'+page;
    }else if(this.state.user_type === 'manager'){
      // uri = APIURL + '/carsale/page/'+page;
      uri = APIURL + '/car/page/'+page;
    }else if(this.state.user_type === 'technician'){
      uri = APIURL + '/cartechnician/page/'+page;
    }


      axios.get(uri)
        .then(res => {
          if(this.mounted) {
            this.setState({
              lists: res.data,
              page: page,
              carLeasingList: []
            })
          }
        }).catch(error => {
        //this.setState({lists: []})
      })

  }

  loadCarDataAsync (page) {
    var uri = ''

    if (typeof page === 'undefined') page = 1

    if(this.state.user_type === 'admin'){
      uri = APIURL + '/car/page/'+page;
    }else if(this.state.user_type === 'manager'){
      uri = APIURL + '/car/page/'+page;
    }else if(this.state.user_type === 'sale'){
      // uri = APIURL + '/carsale/page/'+page;
      uri = APIURL + '/car/page/'+page;
    }else if(this.state.user_type === 'technician'){
      uri = APIURL + '/cartechnician/page/'+page;
    }

    axios.get(uri)
      .then(res => {
        this.setState({
          lists: res.data,
          page: page,
          carLeasingList: []
        })
      }).catch(error => {
      //this.setState({lists: []})
    })
  }

  searchByCarStructure(structure_name) {
    var user_type = this.state.user_type;
    var uri_structure = APIURL + '/car/structure/'+user_type+'/'+structure_name;
    axios.get(uri_structure)
      .then(res => {
        this.setState({
          lists: res.data,
          carLeasingList: []
        })
      }).catch(error => {
      this.setState({lists: []})
    })
  }

    loadCountCarData() {
      var uri = ''
      if(this.state.user_type === 'admin'){
        uri = APIURL + '/car/getcount/count'
      }else if(this.state.user_type === 'sale'){
        uri = APIURL + '/car/getcount/count'
      }else if(this.state.user_type === 'manager'){
        // uri = APIURL + '/carsale/getcount/count';
        uri = APIURL + '/car/getcount/count'
      }else if(this.state.user_type === 'technician'){
        uri = APIURL + '/cartechnician/getcount/count';
      }


       /// console.log('load', uri)
        axios.get(uri)
          .then(res => {
            let sum_cost_all = 0

            if (res.data[0].sum_cost !== undefined) {
              let sum_cost = res.data[0].sum_cost
              let sum_repair = res.data[0].sum_repair
              let sum_other = res.data[0].sum_other
              sum_cost_all = sum_cost + sum_repair + sum_other
            }

            if(this.mounted) {
              this.setState({
                count_car: res.data[0].count_car,
                sum_cost_all: sum_cost_all
              });
            }
          }).catch(error => {
             console.log(error)
        })

    }

  componentDidMount () {
    //if(this.state.load_data)
    this.mounted = true;
    // console.log('CarList componentDidMount')
    this.loadCountCarData()
    this.loadCarData(1)

  }


  onCarStatusEdit (car) {
    this.setState({car_edit_status: car},()=>{
      this.toggleCarStatusEdit()
    })
  }

  toggleCarStatusEdit(){
    this.setState({toggle_car_status_edit: !this.state.toggle_car_status_edit})
  }

  onCarStatusChange(car_id,car_status_id){
    axios.put(APIURL + '/car/car_status/'+car_id,{
      car_id: car_id,
      car_status_id: car_status_id,
    })
    .then(res => {
      this.loadCarData()
      this.toggleCarStatusEdit()
    }).catch(error => {

    })
  }

  toggleCarCalculate() {
    this.setState({
      toggle_car_calculate: !this.state.toggle_car_calculate
    });
  }

  toggleCarDelete() {
    this.setState({
      toggle_car_status_delete: !this.state.toggle_car_status_delete
    });
  }

  toggleCarLeasing() {
    this.setState({
      toggle_car_status_leasing: !this.state.toggle_car_status_leasing
    });
  }

  toggleCarEditSellPrice()  {
    this.setState({
      toggle_car_edit_sell_price: !this.state.toggle_car_edit_sell_price
    });
  }

  toggleCarShare() {
    this.setState({
      toggle_car_share: !this.state.toggle_car_share
    },()=>{
      if(this.state.toggle_car_share===false){
        this.loadCarData(1)
        this.loadCountCarData()
      }
    });

  }

  onCarCalculate(car){
    this.setState({car_calculate: car},()=>{
      this.toggleCarCalculate()
    })
  }
  onCarShare(car){
    this.setState({car_share: car},()=>{
      this.toggleCarShare()
    })
  }

  onCarDelete(car) {
    this.setState({car_delete: car},()=>{
      this.toggleCarDelete()
    })
  }

  onCarLeasing(car) {
    this.setState({car_leasing: car},()=>{
      this.toggleCarLeasing()
    })
  }

  onCarEditSellPrice(car) {
    this.setState({car_edit_sell_price: car},()=>{
      this.toggleCarEditSellPrice()
    })
  }

  onCarShareChange(car_id){
      //alert("onCarShareChange car.car_id="+car_id)
  }

    searchCar () {
        var search_text = this.refs.search_car_name.value
        //alert(search_text);
        if (search_text !== ""){
          this.setState ({is_search: true})
            this.getDataCarSearch(search_text)

        }else {
          this.setState ({is_search: false},()=>{
            this.loadCarData(1)
          })
        }

    }

    getDataCarSearch (search_text) {

      var uri = '';
      if(this.state.user_type === 'admin'){
        uri = APIURL + '/car/search/' + search_text;
      }else if(this.state.user_type === 'sale'){
        // uri = APIURL + '/carsale/search/'+search_text;
        uri = APIURL + '/car/search/' + search_text;
      }else if(this.state.user_type === 'technician'){
        uri = APIURL + '/cartechnician/search/'+search_text;
      }

        axios.get(uri)
            .then(res => {
                this.setState({lists: res.data})
                //alert (res.data)
            }).catch(error => {
            this.setState({lists: []})
        })
    }

  onRefreshCar(){
    this.refs.search_car_name.value = ''
    this.setState ({is_search: false},()=>{
      this.loadCarData(1)
    })
  }

  carDelete(car_id) {
    if(this.state.user_type === 'admin'){
      axios.delete(APIURL + '/car/' + car_id).then(res => {
        if (res.status === 200) {
          this.toggleCarDelete()
          this.loadCarData(1)
          this.loadCountCarData()
        }
      })
    }
  }

  onSubmitCarLeasing(e, leasingData) {
    e.preventDefault();

    var action = e.target.action.value;

     var data = {
       'leasingData': leasingData,
       'user' : this.state.user.user
     }

    if(action==='add') {
      axios.post(APIURL + '/car_leasing/new/' + this.state.car_leasing.car_id, data)
        .then((res) => {
          //if (res.status === 200) {
            this.toggleCarLeasing()
            this.loadCarLeasingList(this.state.car_leasing.car_id)
          //}
        })
        .catch((err) => {
          console.log(err);
        });
    }else if(action==='edit') {
     //edit
      axios.put(APIURL + '/car_leasing/edit/' + this.state.car_leasing.car_id, data)
        .then((res) => {
          if (res.status === 200) {
            this.toggleCarLeasing()
            this.loadCarLeasingList(this.state.car_leasing.car_id)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  async onSubmitCarEditSellPrice(e, SellPrice) {
    e.preventDefault();

    // console.log(SellPrice)
    // let res = await axios.put(APIURL + '/car/car_sell_price/'+SellPrice.car_id, SellPrice)
    let res = await axios.put(APIURL + '/car/car_price/'+SellPrice.car_id, SellPrice)

    if (res.status === 200) {
      await this.loadCarDataAsync(this.state.page)
      this.toggleCarEditSellPrice()
    }
  }

  loadCarLeasingList(car_id) {
    var uri =  APIURL + '/car_leasing/'+car_id;
    axios.get(uri)
      .then(res => {
        this.setState({carLeasingList: res.data})
      }).catch(error => {
      this.setState({carLeasingList: []})
    })
  }


  onCarExplainFormEdit(e, car_id) {
    e.preventDefault();
    var explain = e.target.value;

    var car_list = this.state.lists.map(car => car.car_id===car_id? {...car, car_explain: explain , car_edit: true  } : car);
    this.setState({
      lists: car_list
    });

  }

  onCarExplainUpdate(car_id, car_explain) {
    // update car_explain
    var uri =  APIURL + '/car/car_explain/'+car_id;
    var data = {car_explain: car_explain};
    axios.put(uri,data)
      .then(res => {

         if(res.status===200){
           var car_list = this.state.lists.map(car => car.car_id===car_id? {...car, car_edit: false, car_save: true  } : car);
           this.setState({
             lists: car_list
           });

           setTimeout(() => {
             var car_list = this.state.lists.map(car => car.car_id===car_id? {...car, car_edit: false, car_save: false  } : car);
             this.setState({
               lists: car_list
             });
           }, 2000);
         }
      })
      .catch(error => {

      })
  }

  render () {

    let all_page = Math.ceil(this.state.count_car/PAGE10);
    let page_array = Array.from(Array(all_page).keys());

    let tab_pages = page_array.map((page,index)=>{
          let page_tmp = page+1
          return (
              <li className="page-item" key={index}>
                 <button className="page-link"  onClick={()=>{   this.loadCarData(page_tmp) }}>
                   &nbsp;{page_tmp}&nbsp;
                 </button>
              </li>
          )
      })

    return (
      <div className="card">
        <div className="card-block">
          <div className="row">
            <div className="col-sm-12 col-md-12">
              <div className="card card-accent-info">
                <div className="card-header">
                  <strong> ข้อมูลรถ </strong>
                        <input
                               onChange={this.searchCar.bind(this)}
                               ref="search_car_name"
                               style={styles.searchCar}
                               className="form-control"
                               placeholder="ค้นหารถชื่อรถ หรือทะเบียนรก"
                               type="text"
                        />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <button className="btn btn-primary"
                                style={styles.buttonHeight}
                                onClick={this.onRefreshCar.bind(this)}

                        >
                          <i className="icon-refresh"></i>
                        </button>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <div className="btn-group">
                        <button type="button"
                                className="btn btn-outline-primary  btn-md-width"
                                onClick={()=> this.searchByCarStructure('เก๋ง')}
                        >เก๋ง</button>
                        <button type="button"
                                className="btn btn-outline-danger   btn-md-width"
                                onClick={()=>this.searchByCarStructure('กระบะ')}
                        >กระบะ</button>
                        <button type="button"
                                className="btn btn-outline-success  btn-md-width"
                                onClick={()=>this.searchByCarStructure('แวน')}
                        >แวน</button>
                      </div>

                    <Link to="/cars/new">
                      <button className="btn btn-primary float-right">
                        <i className="icon-plus"></i>&nbsp; เพิ่มข้อมูลรถใหม่
                      </button>
                    </Link>

                </div>

                <div className="card-block">

                  <div className={ this.state.count_car > 0 ? "row col-12 pl-3 pb-2" : "hidden"}>

                    <h4 className="col-4">จำนวนรถทั้งหมด {this.state.count_car} คัน</h4>

                    {
                      this.state.sum_cost_all > 0 && this.state.user_type === 'admin' ?
                        <h4 className="col-4">รวมทุนทั้งหมด {this.state.sum_cost_all.toLocaleString()} บาท</h4>
                        : ''
                    }


                    <Link to="/carin/all">
                      <button className="btn btn-info float-right ">
                        <i className="icon-eye"></i>&nbsp; รายละเอียด
                      </button>
                    </Link>
                  </div>

                  <table className="table table-striped">
                    <thead>
                    <tr>
                      <th className="text-center">#</th>
                      <th className="text-center">รูปรถ</th>
                      <th className="text-center">ชื่อรถ</th>
                      {/*<th className={this.state.user_type ==='admin' ? "text-center" :  "hidden"}>ราคาทุน</th>*/}
                      <th
                          className={this.state.user_type === 'technician' ? 'hidden' : 'text-center'}
                      >
                        ราคา
                      </th>
                      {/*<th className={this.state.user_type ==='admin' ? "text-center" :  "hidden"} >กำไร</th>
                      <th className="text-center">สถานะ</th>*/}
                      <th className="text-center">จัดการ</th>
                    </tr>
                    </thead>

                    <CarRow
                      cars={this.state.lists}
                      onCarStatusEdit={this.onCarStatusEdit}
                      onCarCalculate={this.onCarCalculate}
                      onCarShare = {this.onCarShare}
                      onCarDelete = {this.onCarDelete}
                      onCarLeasing={this.onCarLeasing}
                      onCarEditSellPrice={this.onCarEditSellPrice}
                      user_type={this.state.user_type}
                      carLeasingList = {this.state.carLeasingList}
                      onCarExplainFormEdit = {this.onCarExplainFormEdit}
                      onCarExplainUpdate = {this.onCarExplainUpdate}
                      page = {this.state.page}
                      count = {this.state.count_car}
                    />




                  </table>
                  <ul className= { this.state.is_search ? "hidden" : "pagination" }>

                      {tab_pages}

                    {/*<li className="page-item"><a className="page-link" href="#">Prev</a></li>*/}
                    {/*<li className="page-item active"><a className="page-link" href="#">1</a>*/}
                    {/*</li>*/}
                    {/*<li className="page-item"><a className="page-link" href="#">2</a></li>*/}
                    {/*<li className="page-item"><a className="page-link" href="#">3</a></li>*/}
                    {/*<li className="page-item"><a className="page-link" href="#">4</a></li>*/}
                    {/*<li className="page-item"><a className="page-link" href="#">Next</a></li>*/}
                  </ul>
                </div>
              </div>

              <Modal isOpen={this.state.toggle_car_status_edit} toggle={this.toggleCarStatusEdit} className={'modal-lg '}>
                <ModalBody>
                     <CarEditStatus
                        car = {this.state.car_edit_status}
                        onHandle = {
                          {
                            cancel: this.toggleCarStatusEdit,
                            change: this.onCarStatusChange
                          }
                        }
                     />
                </ModalBody>
              </Modal>

              <Modal isOpen={this.state.toggle_car_calculate} toggle={this.toggleCarCalculate} className={'modal-lg ' + this.props.className}>
                <ModalBody>
                  <CarCalculate
                    car={this.state.car_calculate}
                    onToggle={this.toggleCarCalculate}
                  />
                </ModalBody>
              </Modal>

              <Modal isOpen={this.state.toggle_car_share}
                     toggle={this.toggleCarShare}
                     className={'modal-lg ' + this.props.className}
              >
                <ModalBody>
                  <CarShare
                    car={this.state.car_share}
                    onHandle = {
                      {
                        cancel: this.toggleCarShare,
                        change: this.onCarShareChange
                      }
                    }
                  />
                </ModalBody>
              </Modal>


              <Modal isOpen={this.state.toggle_car_status_delete} toggle={this.toggleCarDelete}
                     className={'modal-danger'}>
                <ModalHeader toggle={this.toggleCarDelete}>ลบข้อมูล</ModalHeader>
                <ModalBody>
                  <strong> คุณต้องการลบข้อมูล {this.state.car_delete.car_name} [{this.state.car_delete.car_id}] ใช่หรือไม่ ?? </strong>
                  <br />(ข้อมูลจะไม่สามารถกู้คืนได้)
                </ModalBody>
                <ModalFooter>
                  <Button color="danger"
                          onClick={this.carDelete.bind(this, this.state.car_delete.car_id)}>ตกลง</Button>{' '}
                  <Button color="secondary" onClick={this.toggleCarDelete}>ยกเลิก</Button>

                </ModalFooter>
              </Modal>


              <Modal isOpen={this.state.toggle_car_status_leasing}
                     toggle={this.toggleCarLeasing}
                     className={'modal-md ' + this.props.className}
              >
                <ModalBody>
                  <CarLeasingFormNew
                    car={this.state.car_leasing}
                    onHandle = {
                      {
                        cancel: this.toggleCarLeasing
                      }
                    }
                    onSubmit = {this.onSubmitCarLeasing}
                  />
                </ModalBody>
              </Modal>

              <Modal isOpen={this.state.toggle_car_edit_sell_price}
                     toggle={this.toggleCarEditSellPrice}
                     className={'modal-md ' + this.props.className}
              >
                <ModalBody>
                  <CarEditSellPrice
                    car={this.state.car_edit_sell_price}
                    onHandle = {
                      {
                        cancel: this.toggleCarEditSellPrice
                      }
                    }
                    onSubmit = {this.onSubmitCarEditSellPrice}
                  />
                </ModalBody>
              </Modal>



            </div>
          </div>
        </div>
      </div>
    )
  }

}
const styles = {
    searchCar: {
        marginLeft: 20,
        width: 300,
        display: 'inline'
    },

    buttonHeight: {
        height: 32,
        paddingTop:0,
        paddingBottom:0,
        display: 'inline',
        marginTop: '-0.35rem'
    }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(CarList)
